import React from 'react'
import { i18n } from '@fs/zion-locale'
import { Trans } from 'react-i18next'

export default {
  title: () => i18n.t('indexedStatusTutorial.title', 'Indexed data in Explore Images'),
  description: () =>
    i18n.t('indexedStatusTutorial.description', 'Learn how Explore Images now integrates with indexed data.'),
  slides: [
    {
      heading: () =>
        i18n.t('indexStatusTutorial.slide1.heading', 'Explore Images includes image groups that have been indexed.'),
      content: () =>
        i18n.t(
          'indexStatusTutorial.slide1.description',
          'This means that transcribed information is available for certain image groups.'
        ),
    },
    {
      heading: () =>
        i18n.t('indexStatusTutorial.slide2.heading', 'In the past, you could only browse images in Explore Images.'),
      content: () => (
        <Trans
          i18nKey="indexStatusTutorial.slide2.description"
          defaults="Now a search icon will appear next to the image group if indexed data is available. Click the <bold>search icon</bold> to search for a name."
          components={{ bold: <strong /> }}
        />
      ),
    },
    {
      heading: () => i18n.t('indexStatusTutorial.slide3.heading', 'Some image groups are only partially indexed.'),
      content: () =>
        i18n.t(
          'indexStatusTutorial.slide3.description',
          'The search icon appears when at least one name in the image group has been indexed. This means that some names may not be searchable yet.'
        ),
    },
    {
      heading: () => i18n.t('indexStatusTutorial.slide4.heading', 'You can see how many images have indexed data.'),
      content: () =>
        i18n.t(
          'indexStatusTutorial.slide4.description',
          'The Options button includes a check box to show the Images Indexed column. This will display the percentage and number of images that have been indexed in the search results.'
        ),
    },
    {
      heading: () => i18n.t('indexStatusTutorial.slide5.heading', 'Many image groups have not been indexed yet.'),
      content: () =>
        i18n.t(
          'indexStatusTutorial.slide5.description',
          "If you don't see the search icon, no indexed data is available for the image groups in your search results."
        ),
    },
    {
      heading: () => i18n.t('indexStatusTutorial.slide6.heading', 'You can still browse through the images.'),
      content: () =>
        i18n.t(
          'indexStatusTutorial.slide6.description',
          'If indexed data is not available, try looking through images one at a time. You may find information that has not been indexed yet.'
        ),
    },
  ],
}
